export enum Bets {
  One = 101,
  Two = 102,
  Five = 103,
  Eight = 107,
  Ten = 104,
  Fifteen = 108,
  Twenty = 105,
  Thirty = 109,
  Forty = 106,
}

export const BetIds = Object.values(Bets).filter((bet) => !isNaN(Number(bet))) as Bets[];

export const BetMapping: Record<string, Bets> = {
  '1': Bets.One,
  '2': Bets.Two,
  '5': Bets.Five,
  '8': Bets.Eight,
  '10': Bets.Ten,
  '15': Bets.Fifteen,
  '20': Bets.Twenty,
  '30': Bets.Thirty,
  '40': Bets.Forty,
};

 export const BetSpotNumber: Record<Bets, number> = {
  [Bets.One]: 1,
  [Bets.Two]: 2,
  [Bets.Five]: 5,
  [Bets.Eight]: 8,
  [Bets.Ten]: 10,
  [Bets.Fifteen]: 15,
  [Bets.Twenty]: 20,
  [Bets.Thirty]: 30,
  [Bets.Forty]: 40,
};
